export const SET_DIMENSIONS = 'SET_DIMENSIONS';

export const dimensionsUpdate = dimensions => dispatch => {
  dispatch(({ type: SET_DIMENSIONS, payload: dimensions }));
};



// WEBPACK FOOTER //
// ./src/reducers/dimensions/actions.js